import React from 'react';
import Message, {getMessage} from '../../../../../components/common/Message';
import Select from 'epic-diesel-form/src/components/form/Select';
import Input from 'epic-diesel-form/src/components/form/Input';
import {OfflinePaymentInfo} from '../../../../../../shared/types/payout/PayoutPublic';
import {isTruthy} from '../../../../../utils/ValidationUtils';
import {FormsySchema, PayoutSchemaKeys} from '../../../../../data/formsy';

//@ts-ignore
import styles from './Payout.pcss';

export interface BankProps {
    messages: Record<string, string>;
    form: OfflinePaymentInfo;
    trigger: (key: string, value: any) => void;
    disabled?: boolean;
    schema: FormsySchema<PayoutSchemaKeys>;
}

const Bank: React.FC<BankProps> = ({messages, form, trigger, disabled, schema}) => {
    const isForeign = isTruthy(form.foreignBank);

    const onChange = event => {
        const {name, value} = event.target;
        trigger(name, value);
    };

    const options = [
        {value: false, label: getMessage(messages, 'epic.affiliate.settings.bank_us')},
        {value: true, label: getMessage(messages, 'epic.affiliate.settings.bank_non_us')}
    ];

    // const bankInformation = (
    //     <div>
    //         <p>{payoutInfoSchema.routingNo.display.toolTip}</p>
    //         <div className="bank-info-image" />
    //     </div>
    // );

    return (
        <div className={styles.section}>
            <h2>
                <Message code="epic.affiliate.settings.bank_title" />
            </h2>
            <p />
            <div className={styles.row}>
                <div>
                    <Select
                        required
                        name={schema.foreignBank.identifier}
                        value={isForeign}
                        options={options}
                        onChange={trigger}
                        disabled={disabled}
                    />
                </div>
                <div>
                    <Input
                        required
                        autoComplete="off"
                        disabled={disabled}
                        name={schema.checkName.identifier}
                        value={form.checkName || ''}
                        placeholder={schema.checkName.display.text}
                        validations={schema.checkName.validations}
                        validationErrors={schema.checkName.validationMessages}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className={styles.row}>
                <div>
                    <Input
                        required
                        autoComplete="off"
                        disabled={disabled}
                        name={schema.bankName.identifier}
                        value={form.bankName || ''}
                        placeholder={schema.bankName.display.text}
                        validations={schema.bankName.validations}
                        validationErrors={schema.bankName.validationMessages}
                        onChange={onChange}
                    />
                </div>
                <div>
                    <Input
                        required={!isForeign}
                        autoComplete="off"
                        disabled={disabled}
                        id={schema.routingNo.identifier}
                        name={schema.routingNo.identifier}
                        type="text"
                        value={form.routingNo || ''}
                        placeholder={schema.routingNo.display.text}
                        validations={schema.routingNo.validations}
                        validationErrors={schema.routingNo.validationMessages}
                        onChange={onChange}
                    />
                </div>
            </div>
            <div className={styles.row}>
                <div className={isForeign ? styles.isForeign : ''}>
                    <Input
                        required
                        autoComplete="off"
                        disabled={disabled}
                        id={schema.bankAccountNo.identifier}
                        name={schema.bankAccountNo.identifier}
                        type="text"
                        value={form.bankAccountNo || ''}
                        placeholder={
                            !isForeign
                                ? schema.bankAccountNo.display.textBankAccountNo
                                : schema.bankAccountNo.display.textIBAN
                        }
                        validations={!disabled && schema.bankAccountNo.validations}
                        validationErrors={schema.bankAccountNo.validationMessages}
                        onChange={onChange}
                    />
                </div>
                {isForeign && (
                    <div>
                        <Input
                            required={isForeign}
                            autoComplete="off"
                            disabled={disabled}
                            name={schema.swiftCode.identifier}
                            value={form.swiftCode || ''}
                            placeholder={schema.swiftCode.display.text}
                            validations={schema.swiftCode.validations}
                            validationErrors={schema.swiftCode.validationMessages}
                            onChange={onChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Bank;
